<template>
  <!-- CONTAINER TO FIX POSITION OF THE CARD -->
	<div class="position-fixed help-panel">
    <!-- CARD -->
    <div v-if="isCardOpen" class="card shadow-lg" :class="$breakpoint.smAndDown ? 'p-4 bottom-100-px' : 'bottom-60-px py-4 px-5'">
      <h3>In Need of Technical Help?</h3>
      <ul class="list-group list-group-flush mx-auto">
        <!-- CONTACT NUMBER -->
        <li class="list-group-item border-0">
          <a class="text-platform-default heading-small font-weight-normal" :href="`tel:${CONTACT_NUMBER}`">
            <i class="fas fa-phone mr-2 text-t_green" />{{ contactNumberText }}
          </a>
        </li>

        <!-- SUPPORT EMAIL -->
        <li class="list-group-item border-0">
          <a class="text-platform-default heading-small font-weight-normal" :href="`mailto:${SUPPORT_EMAIL}`">
            <i class="fas fa-envelope mr-2 text-t_green" />{{ supportEmailText }}
          </a>
        </li>
      </ul>
    <!-- CARD -->
    </div>
    
    <!-- BUTTON TO OPEN/HIDE CARD ABOVE -->
    <button class="btn btn-new--mobile"
      :class="[isCardOpen ? 'btn-destructive' : 'btn-actionable', $breakpoint.smAndDown ? 'btn-icon mb-5' : 'btn-50']"
      @click="openCard()"
    >
      <i class="heading-medium fas" :class="isCardOpen ? 'fa-times' : 'fa-question'" />
    </button>
  <!-- CONTAINER TO FIX POSITION OF THE CARD -->
  </div>
</template>

<script>
import breakpoint from '@/mixins/index';
const platform = process.env.VUE_APP_Platform ?? "DTN";

export default {
  mixins: [breakpoint],
  data(){
    return {
      isCardOpen: false,
      contactNumbers: {
        DTN: "+44 80 8189 0758",
        Greenergy: "+44 80 8189 0758",
        Harvest: "+44 80 8189 0758"
      },
      supportEmails: {
        DTN: "fuelsupport@dtn.com",
        Greenergy: "greenergysupport@dtn.com",
        Harvest: "harvestsupport@dtn.com"
      }
    }
  },
  computed: {
    contactNumberText() {
      return this.contactNumbers[platform];
    },
    supportEmailText() {
      return this.supportEmails[platform];
    }
  },
  methods: {
    openCard: function(){
      this.isCardOpen = !this.isCardOpen;
    }
  }
}
</script>

<style lang="scss" scoped>
.help-panel {
  position: fixed;
  bottom: 75px;
  right: 20px;
  z-index: 999;
}

.bottom- {
  &60-px {
    bottom: 60px;
  }
  &100-px {
    bottom: 100px;
  }
}

.btn-50 {
  width: 50px!important;
  height: 50px;
}
</style>